import React, { useEffect, useRef, useState, useCallback } from "react";
import Styles from "./index.module.css";
import {
  format,
  subMonths,
  formatDistance,
  isAfter,
  isBefore,
  startOfDay,
  endOfDay,
} from "date-fns";
import { machineProfile } from "../../api";
import { Card, CardBody, CardHeader, CardFooter } from "../card/card";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { DateRange } from "../DateRange";
import ConfirmationDlg from "../ConfirmationDlg";
import ReportData from "./report";
import Swal from "sweetalert2";
import "@sweetalert2/theme-dark/dark.css";
const getStatus = (status) => {
  switch (status) {
    case "Acceptable":
      return "accept";
    case "Observe":
      return "observe";
    case "Alert":
      return "alert";
    case "Critical":
      return "critical";
    default:
      return "pending";
  }
};

const isNewMonth = (data) => {
  const date = new Date(data);

  return date.getDate() == 1;
};

const getMonth = (data) => {
  return format(new Date(data), "MMM");
};

export const MachineHealth = ({ machine }) => {
  const windowSize = useRef([window.innerWidth, window.innerHeight]);
  console.log("windowSize", windowSize);
  const [openModal, setOpenModal] = React.useState(false);
  const [date, setDate] = useState({
    startDate: startOfDay(subMonths(new Date(), 12)),
    endDate: endOfDay(new Date()),
  });
  const [machineHealth, setMachineHealth] = useState([]);
  const [pastMachineHealth, setPastMachineHealth] = useState([]);

  const MachineHealthDetail = ({ data }) => {
    const upvote = async () => {
      const upVoteProcess = async () => {
        await machineProfile.feedback({
          id: data.id,
          feedback_type: "Up-vote",
          feedback: "Has Up-vote this machine health",
        });
        getHealth();
      };
      Swal.fire({
        title: "Upvote",
        text: "Are you sure you want to upvote this machine health?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) upVoteProcess();
      });
    };
    const downvote = async () => {
      const downVoteProcess = async () => {
        await machineProfile.feedback({
          id: data.id,
          feedback_type: "Down-vote",
          feedback: "Has Down-vote this machine health",
        });
        getHealth();
      };

      Swal.fire({
        title: "Down-vote",
        text: "Are you sure you want to Down-vote this machine health?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) downVoteProcess();
      });
    };
    const comment = async () => {
      const commentProcess = async (value) => {
        await machineProfile.feedback({
          id: data.id,
          feedback_type: "comment",
          feedback: value,
        });
        getHealth();
      };

      Swal.fire({
        title: "Comment",
        text: "Please write the comment",
        icon: "question",
        input: "text",
        inputValidator: (value) => {
          if (!value) {
            return "You need to write something!";
          }
        },
        showCancelButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.value) commentProcess(result.value);
      });
    };
    return (
      <Card className="border-theme mb-3 mt-3">
        <CardHeader className="border-theme fw-bold small text-theme d-flex">
          <div className="flex-1">
            <span
              className={`badge bg-${getStatus(data.status)}`}
              style={{ color: "black" }}
            >
              {data.status}
            </span>{" "}
            Machine Health
          </div>
          <div>
            {" "}
            {format(new Date(data.created_at), "dd MMMM yyyy | HH:mm ")}
          </div>
        </CardHeader>
        <CardBody>
          <p
            className="card-text text-opacity-75"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {data.description}
          </p>
          <div
            className="border-theme small text-theme text-bold"
            style={{
              padding: "0 5px",
              border: "1px solid",
              position: "absolute",
              right: "10px",
              bottom: "7px",
            }}
          >
            GINA.AI
          </div>
        </CardBody>
        <CardFooter>
          <button
            onClick={upvote}
            className="border-theme bg-opacity-25 bg-success mx-2"
          >
            <i className="fa fa-thumbs-up"></i>
          </button>
          <button
            onClick={downvote}
            className="border-danger bg-opacity-25 bg-danger mx-2"
          >
            <i className="fa fa-thumbs-down"></i>
          </button>
          <button
            onClick={comment}
            className="border-theme bg-opacity-25 bg-success mx-2"
          >
            <i className="fa fa-comment"></i>
          </button>
        </CardFooter>
        {data.feedback.length ? (
          <CardFooter className={"border-theme"}>
            {data.feedback.map((feedback, index) => (
              <div
                key={index}
                className="d-flex"
                style={{
                  marginBottom: "10px",
                  borderBottom: "1px solid #286f59",
                }}
              >
                <div className="flex-1">
                  <div className=" text-bold text-white">
                    {feedback.user.firstname}
                  </div>
                  <div className="text-theme">{feedback.feedback}</div>
                </div>
                <div>
                  <span
                    className="text-white-50"
                    style={{
                      fontSize: "10px",
                    }}
                  >
                    {format(
                      new Date(feedback.created_at),
                      "dd MMMM yyyy | HH:mm"
                    )}
                  </span>
                </div>
              </div>
            ))}
          </CardFooter>
        ) : null}
      </Card>
    );
  };
  const getHealth = async () => {
    let start = "";
    let end = "";

    start = date.startDate;
    end = date.endDate;

    const result = await machineProfile.listMachineHealth({
      start_date: start,
      end_date: end,
      machine_id: machine.id,
      feedback: true,
    });

    if (result.ok) {
      const body = await result.json();
      if (body.data.length) {
        setMachineHealth(body.data);
      } else {
        setMachineHealth([]);
      }
    }
  };
  useEffect(() => {
    getHealth();
  }, [machine, date]);

  const handleChangeDate = (startDate, endDate) => {
    setDate({
      startDate,
      endDate,
    });
  };
  useEffect(() => {
    const getHealth = async () => {
      const result = await machineProfile.listMachineHealth({
        start_date: new Date("01-01-2020"),
        end_date: new Date(),
        machine_id: machine.id,
      });

      if (result.ok) {
        const body = await result.json();

        if (body.data.length) {
          setPastMachineHealth(body.data.reverse());
        }
      }
    };

    getHealth();
  }, [machine]);

  const windowMinSize =
    windowSize.current[0] < 500 ? 500 : windowSize.current[0];
  const hwidth =
    pastMachineHealth.length > 0 ? windowMinSize / pastMachineHealth.length : 0;

  const latestMachineHealth =
    machineHealth.length > 0 ? machineHealth[machineHealth.length - 1] : null;
  let cnm = 0;

  const [width, setWidth] = useState(null);
  const [widthItem, setWidthItem] = useState(null);
  useEffect(() => {
    if (pastMachineHealth.length > 0) {
      setWidthItem((width - 0) / pastMachineHealth.length);
    }
  }, [pastMachineHealth]);
  const div = useCallback((node) => {
    if (node !== null) {
      const widthParent = node.getBoundingClientRect().width;
      setWidth(widthParent);
    }
  }, []);

  const submitHandler = () => {
    setOpenModal(false);
  };
  const openModalDetail = () => {
    setOpenModal(true);
  };

  return (
    <div>
      <ConfirmationDlg
        dialogClassName="modal-90w"
        size={"xl"}
        open={openModal}
        hideCancelBtn={true}
        btnSubmitText={"Close"}
        onSubmit={submitHandler}
        onClose={submitHandler}
      >
        <h4>Machine Health Analytics Comparison</h4>
        <div className="my-2">
          <ReportData
            machineId={machine.id}
            pastMachineHealth={pastMachineHealth}
          />
        </div>
      </ConfirmationDlg>
      <div style={{ display: "flex", position: "relative" }} mb={1}>
        <div
          style={{
            textAlign: "left",
            fontWeight: "bold",
            fontSize: 13,
          }}
        >
          Past Machine Health Classification
        </div>
        <div style={{ position: "absolute", right: "0px", top: "0px" }}>
          <DateRange
            onChange={handleChangeDate}
            startDate={date.startDate}
            endDate={date.endDate}
          />
        </div>
      </div>

      <div
        style={{
          marginTop: "20px",
          textAlign: "left",
          marginBottom: "50px",
        }}
      >
        <div
          className={Styles.blockContainer}
          ref={div}
          style={{ marginTop: "10px", boxShadow: "none" }}
        >
          {pastMachineHealth.length > 0 && (
            <div
              style={{
                display: "flex",
                marginTop: "0px",
                marginBottom: "10px",
                //overflow: "hidden",
                //border: "1px solid red",
                paddingBottom: "50px",
                paddingLeft: "0px",
                paddingTop: "0px",

                height: "70px",
              }}
            >
              {pastMachineHealth.map((mh, index) => {
                let renderLine = false;

                if (cnm != new Date(mh.created_at).getMonth()) {
                  renderLine = true;
                  cnm = new Date(mh.created_at).getMonth();
                } else {
                  renderLine = false;
                }

                return (
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    key={index}
                    placement={"bottom"}
                    overlay={
                      <Popover
                        id={`popover-positioned-bottom`}
                        style={{ borderRadius: "0" }}
                      >
                        <Popover.Header as="h3" className="text-white">
                          {" "}
                          {format(new Date(mh.created_at), "dd MMMM yyyy")}
                        </Popover.Header>
                        <Popover.Body>{mh.status}</Popover.Body>
                      </Popover>
                    }
                  >
                    <div
                      key={index}
                      style={{ display: "flex", height: "70px" }}
                    >
                      {renderLine && (
                        <div style={{ position: "relative" }}>
                          <div
                            style={{
                              background: "#c3bebe",
                              width: "2px",
                              height: "70px",
                              marginTop: "-0px",
                            }}
                          ></div>
                          <div
                            style={{
                              position: "absolute",
                              //left: "-10px",
                              marginTop: "5px",
                              fontSize: 12,
                            }}
                          >
                            {getMonth(mh.created_at)}
                          </div>
                        </div>
                      )}
                      <div
                        className={Styles[getStatus(mh.status)]}
                        style={{
                          height: "70px",
                          width: widthItem,
                          cursor: "pointer",
                        }}
                      ></div>
                    </div>
                  </OverlayTrigger>
                );
              })}
            </div>
          )}
          {pastMachineHealth.length == 0 && <div>Insufficient Data</div>}
        </div>
      </div>

      <div
        style={{
          textAlign: "left",
          fontWeight: "bold",
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          fontSize: 13,
        }}
        className="mt-4 mb-1"
      >
        <div>Machine Health Updates</div>
        <button className=" btn btn-outline-theme" onClick={openModalDetail}>
          <i className="fa fa-chart-line"></i> Compare Data{" "}
        </button>
      </div>
      <div className="mt-3">
        {machineHealth.length > 0 && (
          <>
            {machineHealth.map((mh, i) => (
              <MachineHealthDetail key={i} data={mh} />
            ))}
          </>
        )}

        {machineHealth.length == 0 && <div>Insufficient Data</div>}
      </div>
    </div>
  );
};
